export const preparationRoutesConfig = {
    introduction: '',
} as const;
